export default "__VITE_ASSET__Cks3PylL__"